import { useState } from "react";
import { FlaskConical, Search, Home as HomeIcon, ShieldCheck } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import PageHeader from "@/components/PageHeader";

const TESTS = [
  { name: "Complete Blood Count (CBC)", price: 299, tag: "Popular" },
  { name: "Full Body Checkup (80+ tests)", price: 1499, tag: "Best value" },
  { name: "Diabetes Panel (HbA1c + Fasting)", price: 499 },
  { name: "Thyroid Profile (T3 T4 TSH)", price: 399 },
  { name: "Lipid Profile", price: 449 },
  { name: "Liver Function Test (LFT)", price: 549 },
  { name: "Kidney Function Test (KFT)", price: 549 },
  { name: "Vitamin D & B12", price: 899 },
];

export default function FindLabs() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const filtered = TESTS.filter((t) => t.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="max-w-3xl" data-testid="find-labs-page">
      <PageHeader title="Book Lab Test" subtitle="Home sample collection · accredited labs" icon={FlaskConical} color="#16A34A" />

      <div className="relative mb-4">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search tests e.g. thyroid, CBC, vitamin D" className="rounded-2xl h-12 pl-11" data-testid="labs-search" />
      </div>

      <div className="flex items-center gap-2 rounded-2xl bg-[#16A34A]/10 px-4 py-3 mb-4">
        <HomeIcon className="h-5 w-5 text-[#16A34A]" />
        <p className="text-sm text-foreground">Free home sample collection on orders above ₹499.</p>
      </div>

      <div className="space-y-2.5">
        {filtered.map((t) => (
          <Card key={t.name} className="rounded-2xl p-4 border-border flex items-center gap-3" data-testid={`lab-test-${t.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <div className="h-10 w-10 rounded-xl bg-[#16A34A]/10 flex items-center justify-center shrink-0"><FlaskConical className="h-5 w-5 text-[#16A34A]" /></div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-sm truncate">{t.name}</p>
              <p className="text-sm text-muted-foreground">₹{t.price}{t.tag && <span className="ml-2 text-[10px] font-bold text-[#16A34A] bg-[#16A34A]/10 px-2 py-0.5 rounded-full">{t.tag}</span>}</p>
            </div>
            <Button size="sm" className="rounded-xl bg-[#16A34A]" onClick={() => { toast.success("We'll connect you to book this test."); navigate("/care-hub"); }} data-testid="lab-book">Book</Button>
          </Card>
        ))}
        {filtered.length === 0 && <p className="text-sm text-muted-foreground text-center py-8">No tests match "{q}".</p>}
      </div>

      <p className="flex items-center justify-center gap-1.5 text-xs text-muted-foreground mt-4">
        <ShieldCheck className="h-3.5 w-3.5" /> Samples handled by NABL-accredited partner labs.
      </p>
    </div>
  );
}
